<template>
  <div class="help-area">
    <a
      href="mailto:info@lending-well.com"
      class="default-btn link small">
      Contact Us
    </a>
    <button
      class="default-btn link small begin-lender-tour"
      @click="beginLenderTour"
    >Help</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HelpArea',

  computed: {
    ...mapState('feathers', {
      client: 'client',
    }),
  },

  methods: {
    beginLenderTour () {
      this.client.emit('beginTour:lenderIntroTour')
    },
  },
}
</script>

<style lang="scss" scoped>
.help-area {
  position: absolute;
  right: 5%;
  top: 20px;

}

.default-btn {
  position: relative;
  padding: 0 10px !important;

  &:first-child:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: -2px;
    width: 1px;

    background-color: #D1D1D1;
  }
}
</style>
